import {useEffect, useState} from 'react'

import 'flatpickr/dist/themes/airbnb.css'
import Flatpickr from 'react-flatpickr'
import {useIntl} from 'react-intl'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

interface FilterDrawerProps {
  open: boolean
  setOpen: (open: boolean) => void
  search: string
  setSearch: (search: string) => void
  setFilter: (filter: any) => void
  badges: {key: string; value: string}[]
  setBadges: (badges: {key: string; value: string}[]) => void
}

export default function FilterDrawer({
  open,
  setOpen,
  search,
  setSearch,
  setFilter,
  badges,
  setBadges,
}: FilterDrawerProps) {
  const intl = useIntl()
  const [value, setValue] = useState('')
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)

  useEffect(() => {
    setValue(search)
  }, [search])

  const submitFilter = () => {
    let date: any = []
    let newBadges: {key: string; value: string}[] = badges

    if (startDate) {
      const year = new Date(startDate).getFullYear()
      const month =
        new Date(startDate).getMonth() < 9
          ? `0${new Date(startDate).getMonth() + 1}`
          : new Date(startDate).getMonth() + 1
      const day = new Date(startDate).getDate()

      const dateM = `${year}-${month}-${day}T00:00:00.000Z`

      date = [
        {
          key: 'crtdDt', //Enrollment Date
          operator: 9, //GreaterThan
          logicalOp: 2,
          value: [dateM],
          childFilters: [],
        },
      ]

      if (newBadges.find((x: any) => x.key === 'startDate')) {
        newBadges = newBadges.filter((x: any) => x.key !== 'startDate')
      }

      newBadges.push({key: 'startDate', value: new Date(startDate).toLocaleDateString()})
    }

    if (endDate) {
      const year = new Date(endDate).getFullYear()
      const month =
        new Date(endDate).getMonth() < 9
          ? `0${new Date(endDate).getMonth() + 1}`
          : new Date(endDate).getMonth() + 1
      const day = new Date(endDate).getDate()

      const dateM = `${year}-${month}-${day}T23:59:59.000Z`

      date = [
        ...date,
        {
          key: 'crtdDt', //Enrollment Date
          operator: 10, //LessThan
          logicalOp: 2,
          value: [dateM],
          childFilters: [],
        },
      ]

      if (newBadges.find((x: any) => x.key === 'endDate')) {
        newBadges = newBadges.filter((x: any) => x.key !== 'endDate')
      }

      newBadges.push({key: 'endDate', value: new Date(endDate).toLocaleDateString()})
    }

    setFilter([
      {
        key: 'fllNm',
        operator: 14,
        logicalOp: 2,
        value: [value],
        childFilters: [
          {
            key: 'emlAddrss',
            operator: 14,
            logicalOp: 2,
            value: [value],
            childFilters: [],
          },
          {
            key: 'mblPhn',
            operator: 14,
            logicalOp: 2,
            value: [value],
            childFilters: [],
          },
          {
            key: 'mmbrNo',
            operator: 14,
            logicalOp: 2,
            value: [value],
            childFilters: [],
          }
        ],
      },
      ...date,
    ])

    if (value !== '') {
      // newBadges.push({ key: 'search', value: value });
      newBadges[0] = {key: 'search', value: value}
    }

    setBadges([...newBadges])
    setOpen(false)
  }

  const startDateTime = startDate ? toTimestamp(startDate) : 0
  const endDateTime = endDate ? toTimestamp(endDate) : 0

  const dateValidate: boolean = startDate && endDate && startDateTime > endDateTime ? true : false

  function toTimestamp(strDate) {
    var datum = Date.parse(strDate)
    return datum / 1000
  }

  return (
    <>
      {open && <div className='drawer-overlay' onClick={() => setOpen(false)}></div>}
      <div
        className={`bg-body custom-drawer drawer drawer-end ${open ? 'drawer-on' : ''}`}
        // id='kt_filter'
        // data-kt-drawer='true'
        // data-kt-drawer-name='filter'
        // data-kt-drawer-activate='true'
        // data-kt-drawer-overlay='true'
        // data-kt-drawer-width="{default:'350px', 'md': '525px'}"
        // data-kt-drawer-direction='end'
        // data-kt-drawer-toggle='#kt_filter_toggle'
        // data-kt-drawer-close='#kt_filter_close'
      >
        <div className='card rounded-0 w-100'>
          <div className='card-header pe-5'>
            <div className='card-title'>
              <div className='d-flex justify-content-center flex-column me-3'>
                <span className='fs-4 fw-bolder text-gray-900 text-hover-primary me-1 lh-1'>
                  {intl.formatMessage({id: 'GLOBAL.FILTER.SELECTED'})}
                </span>
              </div>
            </div>

            <div className='card-toolbar'>
              <button
                className='btn btn-sm btn-icon btn-active-light-primary'
                // id='kt_filter_close'
                onClick={() => {
                  setOpen(false)
                }}
              >
                <span className='svg-icon svg-icon-2'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                  >
                    <rect
                      opacity='0.5'
                      x='6'
                      y='17.3137'
                      width='16'
                      height='2'
                      rx='1'
                      transform='rotate(-45 6 17.3137)'
                      fill='black'
                    ></rect>
                    <rect
                      x='7.41422'
                      y='6'
                      width='16'
                      height='2'
                      rx='1'
                      transform='rotate(45 7.41422 6)'
                      fill='black'
                    ></rect>
                  </svg>
                </span>
              </button>
            </div>
          </div>
          <div className='card-body hover-scroll-overlay-y'>
            <form id='filterForm'>
              <div className='px-7 py-5'>
                <div className='mb-5'>
                  <label className='form-label fw-bold d-flex align-items-center gap-2'>
                    <span>{intl.formatMessage({id: 'GLOBAL.FILTER.SEARCH.MEMBER'})}:</span>

                    {/* <OverlayTrigger
                      overlay={
                        <Tooltip>{intl.formatMessage({id: 'MEMBER.FILTER.SEARCH'})}</Tooltip>
                      }
                    >
                      <i className='bi bi-info-circle fs-4 ms-2'></i>
                    </OverlayTrigger> */}
                  </label>

                  <div className='row'>
                    <div className='col-md-12 mb-4'>
                      <input
                        className='form-control mr-sm-2'
                        type='search'
                        name='productSelectedSearch'
                        placeholder={intl.formatMessage({id: 'MEMBER.FILTER.SEARCH.2'})}
                        aria-label='Search'
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className='mb-5'>
                  <label className='form-label fw-bold'>
                    {intl.formatMessage({id: 'GLOBAL.FILTER.ENROLLMENT_DATE'})}:
                  </label>

                  <div className='row'>
                    <div className='col-md-6 mb-4'>
                      <Flatpickr
                        placeholder={intl.formatMessage({id: 'GLOBAL.FILTER.START_DATE'})}
                        value={startDate}
                        onChange={(date) => {
                          setStartDate(date)
                        }}
                        name='startDate'
                        className='form-control mb-2'
                        options={{
                          dateFormat: 'm/d/Y',
                          // maxDate: new Date(
                          //   new Date().getFullYear(),
                          //   new Date().getMonth(),
                          //   new Date().getDate()
                          // ),
                        }}
                      />
                    </div>
                    <div className='col-md-6 mb-4'>
                      <Flatpickr
                        placeholder={intl.formatMessage({id: 'GLOBAL.FILTER.END_DATE'})}
                        value={endDate}
                        onChange={(date) => {
                          setEndDate(date)
                        }}
                        name='endDate'
                        className='form-control mb-2'
                        options={{
                          dateFormat: 'm/d/Y',
                          // maxDate: new Date(
                          //   new Date().getFullYear(),
                          //   new Date().getMonth(),
                          //   new Date().getDate()
                          // ),
                        }}
                      />
                      {dateValidate && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            {intl.formatMessage({
                              id: 'GLOBAL.VALIDATION.END_DATE_MUST_BE_GREATER_THAN_START_DATE',
                            })}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div className='card-footer'>
            <div className='row'>
              <div className='col-md-6'>
                <button
                  type='reset'
                  className='btn w-100 btn-sm btn-light-danger'
                  onClick={() => {
                    setBadges([])
                    setFilter([])
                    setSearch('')
                    setValue('')
                    setStartDate(null)
                    setEndDate(null)
                    setOpen(false)
                  }}
                >
                  {intl.formatMessage({id: 'GLOBAL.FILTER.CLEAR'})}
                </button>
              </div>
              <div className='col-md-6'>
                <button
                  className='btn w-100 btn-sm btn-primary'
                  disabled={dateValidate}
                  onClick={() => {
                    submitFilter()
                    setSearch(value)
                  }}
                >
                  {intl.formatMessage({id: 'GLOBAL.FILTER.SEARCH'})}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
